import { render, staticRenderFns } from "./DirectionsUniversity.vue?vue&type=template&id=79316969&scoped=true&"
import script from "./DirectionsUniversity.vue?vue&type=script&lang=js&"
export * from "./DirectionsUniversity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79316969",
  null
  
)

export default component.exports